import styled from "styled-components"
import mixins from "../../../styles/mixins";

const Wrap = styled.section`
    max-width: 227px;
    }
    .cause-solution-list {
    li {
        gap: 0 6px;
        ${mixins.body2};
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;

        .no {
            display: inline-block;
            width: 20px;
            flex-shrink: 0;
            font-size: 14px;
            line-height: calc(22.4 / 14);
            font-weight: 500;
            color: rgba(28, 195, 145, 1);
        }

        &.danger {
            color: rgba(184, 47, 39, 1);
        }
    }
`;
export default function RelatedKeyword({list}) {
    return (
        <Wrap className="cause-solution">
            <div className="h4">관련 키워드</div>
            <ul className="cause-solution-list">
                {
                    list && 
                    list.map((el, idx) => {
                        return (
                            <li key={idx} className={el.isNegative ? "danger" : ""}>
                                <div className="no">{idx + 1}</div>
                                {el.keyword}
                            </li>
                        )
                    })
                }
            </ul>
        </Wrap>
    )
}